import {
  Associate,
  useGetRetailerStoreOpeningHours,
} from '@vs-online-only-app/state';
import { intervalToDuration } from 'date-fns';
import { useMemo } from 'react';

export const useAssociateStore = (associate?: Associate) => {
  const { data: store } = useGetRetailerStoreOpeningHours(associate?.storeId);
  const isStoreOpen = useMemo(() => Boolean(store?.businessOpen), [store]);
  const durationUntilStoreOpens = useMemo(
    () =>
      store
        ? intervalToDuration({
            start: new Date(new Date().toISOString()),
            end: new Date(
              (store.openToday
                ? store.openingTime
                : store.nextOpeningTime) as string,
            ),
          })
        : null,
    [store],
  );

  const { hours, minutes } = durationUntilStoreOpens || {};

  const formattedTimeUntilStoreOpens = `${
    hours ? `${hours} hours${minutes ? ` and ` : ''}` : ''
  }${minutes ? `${minutes} minutes` : ''}`;

  return { isStoreOpen, formattedTimeUntilStoreOpens };
};
